import React from "react";
import { Router } from "@gatsbyjs/reach-router";
import Betting from "./Betting";
import MatchPage from "./Match/MatchPage";
import OutrightPage from "./Match/OutrightPage";
import { RaceMeeting } from "@/features/racing/components/RaceMeeting";
import useDisableNativeScrollRestoration from "hooks/useDisableNativeScrollRestoration";
import { useTitles } from "hooks/graphql/useTitles";
import { Racing } from "@/features/racing/components/Racing";
import { Race } from "sections/Betting/Race";

const Layout = (props: any) => {
  const {
    pageContext: { hub, locale, title },
  } = props;
  useDisableNativeScrollRestoration();
  const regionPrefix =
    typeof window !== "undefined" &&
    locale.toLowerCase() === window.___defaultLocale
      ? ``
      : `${locale.toLowerCase()}/`;

  const hubPrefix =
    hub === "sports" ? "sports/" : hub === "racing" ? "racing/" : "";

  const titlePrefix = title ?? "";

  const basePath = `${regionPrefix}${hubPrefix}${titlePrefix}betting`;

  const titles = useTitles();

  return (
    <Router basepath={basePath} primary={false}>
      <MatchPage path="/match/*" titles={titles} />
      <OutrightPage path="/outright/:id" titles={titles} />
      <Race path="/race/:meetingId/:raceId/*" />
      <RaceMeeting path="/meeting/:id/*" titles={titles} />

      {hub === "racing" ? (
        <Racing title={title} path="/" {...props} default />
      ) : (
        <Betting path="/" {...props} default />
      )}
    </Router>
  );
};

export default Layout;
